const ErrorFallbackComponent: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          Si è verificato un errore
        </h1>
        <p className="text-gray-600 mb-6">
          Ci scusiamo per l'inconveniente. L'errore è stato segnalato e stiamo lavorando per risolverlo.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
        >
          Ricarica la pagina
        </button>
      </div>
    </div>
  );
};
export default ErrorFallbackComponent;